export const Get_Freight_Options = "Get_Freight_Options";
export const Reset_Freight_Options = "Reset_Freight_Options";
export const Set_Selected_Freight_Zone = "Set_Selected_Freight_Zone";
export const Reset_Selected_Freight_Zone = "Reset_Selected_Freight_Zone";
export const Set_Selected_Freight_Tier = "Set_Selected_Freight_Tier";
export const Reset_Selected_Freight_Tier = "Reset_Selected_Freight_Tier";
export const Set_Selected_Freight_Tier_Attribute = "Set_Selected_Freight_Tier_Attribute";
export const Reset_Selected_Freight_Tier_Attribute = "Reset_Selected_Freight_Tier_Attribute";
export const Set_Filtered_Freight_Zones = "Set_Filtered_Freight_Zones";
export const Reset_Filtered_Freight_Zones = "Reset_Filtered_Freight_Zones";